

export default {
  name: 'coordinateDisplay',

  getReducer(){
    const initialState = {
      x: "0.0000",
      y: "0.0000"
    }

    return (state = initialState, { type, payload }) => {

      if(type === 'COORD_POSITION_UPDATE'){
        return Object.assign({}, state, payload);
      }

      return state;
    }
  },

  doUpdateCoords: (x, y) => ({dispatch}) => {
    dispatch({type:'COORD_POSITION_UPDATE', payload: { x, y }})
  },

  selectX: (state) => {
    return state.coordinateDisplay.x;
  },

  selectY: (state) => {
    return state.coordinateDisplay.y;
  }
}